export default "__VITE_ASSET__C$K22uLu__"